// extracted by css-extract-rspack-plugin
export default {"period-wrapper":"AuctionPeriod-module__period-wrapper--i9mbe","periodWrapper":"AuctionPeriod-module__period-wrapper--i9mbe"};